import { getMYCAGlobalDomain } from '@americanexpress/rerouter';
import getSupportedLocale from '../utils/getIsSupportedLocale';

export const getUnsupportedMarketProductRedirectUrls = (state) => {
  const domain = getMYCAGlobalDomain(state);
  return {
    'es-AR': '/statements',
    'zh-TW': '/statements',
    'te-ST': `${domain}/myca/intl/acctsumm/canlac/accountSummary.do?request_type=&Face=es_AR`,
    'pt-BR': `${domain}/myca/estatement/canlac/action?request_type=authreg_CardsList&Face=pt_BR`,
  };
};

export default function mycaUnsupportedMarketProductRedirect({ state, locale }) {
  const urls = getUnsupportedMarketProductRedirectUrls(state);

  if (!getSupportedLocale(locale)) {
    return {
      redirectUrl: urls[locale] || 'https://www.americanexpress.com/change-country/',
    };
  }

  return {};
}
